export default "__VITE_ASSET__B6ELjIXK__"